<template>
  <div class="pay_query--wrapper">
    <div class="pay_query">
      <img class="loading" src="@/assets/imgs/loader.gif" />
      <div class="loading_txt">支付结果查询中，请稍等</div>
    </div>
  </div>
</template>

<script>
import types from "@/store/types";
import api from "@/utils/api";
import utils from "@/utils";

export default {
  name: "PayResult",
  data() {
    return {
      loaded: 0,
      status: 1
    }
  },
  created() {
    let sn = this.$route.query.sn;
    if (sn) {
      this.loadSource(sn);
    } else {
      console.warn("缺少必要参数OrderSN");
      // this.$router.replace({ path: "/" });
    }
  },
  methods: {
    loadSource(sn) {
      api[types.ORDER_GA_QUERY]({ order_sn: sn }).then(res => {
        let oInfo = res.data;
        if (oInfo.order_sn) {
          let trackedSN = JSON.parse(utils.getItem("gtm_sn") || "[]");
          let isTracked = trackedSN.includes(parseInt(oInfo.order_sn));
          // COD 订单处理
          if (this.$route.query.cod == 1) {
            if (!isTracked) {
              // 小程序创建的订单不上报GA
              if(oInfo.channel == 2 || oInfo.channel == 3) this.gtmTrackPurchase(oInfo);
              this.ylTrackPayment(oInfo);
              this.paysuccessreport(oInfo);
              utils.setItem('gtm_sn', JSON.stringify([...trackedSN, parseInt(oInfo.order_sn)]));
            }
            this.$router.replace({
              path: `/payresult?sn=${sn}&extras=2_${this.toPCI(oInfo.trade_type)}_0_0_${oInfo.total_amount}`
            });
            return;
          }
          // 正常订单处理
          if (oInfo.payResult == "success") {
            if (!isTracked) {
              // 小程序创建的订单不上报GA
              if(oInfo.channel == 2 || oInfo.channel == 3) this.gtmTrackPurchase(oInfo);
              this.ylTrackPayment(oInfo);
              this.paysuccessreport(oInfo);
              this.bdTrackPayment(oInfo);
              utils.setItem('gtm_sn', JSON.stringify([...trackedSN, parseInt(oInfo.order_sn)]));
            }
            this.$router.replace({
              path: `/payresult?sn=${sn}&extras=1_${this.toPCI(oInfo.trade_type)}_${this.toPMI(oInfo.payment_type)}_${oInfo.huabei_period}_${oInfo.total_amount}`
            });
          } else {
            this.$router.replace({
              path: `/payresult?sn=${sn}&extras=0_${this.toPCI(oInfo.trade_type)}_${this.toPMI(oInfo.payment_type)}_${oInfo.huabei_period}_${oInfo.total_amount}`
            });
          }
        } else {
          console.warn(res);
          this.$router.replace({ path: `/myaccount/orders?sn=${sn}` });
        }
      }).catch(err => {
        console.warn(err);
        this.$router.replace({ path: `/myaccount/orders?sn=${sn}` });
      });
    },
    // Payment Channel Index
    toPCI(paymentChannel) {
      return { "NATIVE": 1, "MWEB": 2, "JSAPI": 3 }[paymentChannel] || 1;
    },
    // Payment Method Index
    toPMI(paymentMethod) {
      if(!isNaN(paymentMethod)) return paymentMethod
      return { "Offline": 0, "AliPay": 1, "WeixinPay": 2, "UnionPay": 3, "HuabeiPay": 4 }[paymentMethod] || 1;
    },
    // GTM Products
    gtmItemsHelper(orderInfo) {
      return orderInfo.detail.goods_list.reduce((ret, curr) => {
        return {
          items: ret.items.concat(curr.main.map(item => {
            return {
              id: item.sku,
              name: item.name,
              price: item.original_price,
              quantity: item.qty,
              productType: ['collection', 'collection_sku'].indexOf(item.display_type) != -1 ? 'bundle' : item.origin_product_data?.skus?.length > 1 ? 'configured' : 'simple',
              position: ret.count,
              pid: item.product_id
            };
          })),
          count: ret.count + curr.main.length
        }
      }, { items: [], count: 0 }).items;
    },
    // GTM 付款成功
    gtmTrackPurchase(orderInfo) {
      if (!window.dataLayer || !orderInfo?.order_sn) return false;
      window.dataLayer.push({
        ecommerce: {
          currencyCode: 'CNY',
          purchase: {
            actionField: {
              step: 5,
              currencyCode: 'CNY',
              id: orderInfo.order_sn,                                                                      // Order ID
              affiliation: orderInfo.trade_type != 'NATIVE' ? 'Mobile' : 'Desktop',                        // Store name
              revenue: orderInfo.total_amount,                                                             // 总金额（含增值税，含运费）
              revenueHt: orderInfo.total_amount,                                                           // 总金额（不含增值税），包括运费
              tax: '0.00',                                                                                 // 税费
              shipping: orderInfo.detail.money_info.total_ship_fee,                                        // 邮费
              transactionGift: 'False',                                                                    // Gift
              transactionShippingService: 'SF',                                                            // 快递
              transactionShippingFree: orderInfo.detail.money_info.total_ship_fee == 0 ? 'True' : 'False', // 免邮
              transactionPayment: orderInfo.payment_type || '',                                            // 支付方式
              coupon: '',                                                                                  // 优惠码
              coupon_id: ''                                                                                // 优惠券ID
            },
            products: this.gtmItemsHelper(orderInfo)
          }
        }
      });
    },
    // 品数监测# 付款
    ylTrackPayment(orderInfo) {
      if (window?.YLTrackerz?.track) {
        window.YLTrackerz.track({
          type: 'payment',
          orderId: orderInfo.order_sn,
          total: orderInfo.total_amount,
          checkout: orderInfo.total_amount,
          shipping: orderInfo.detail.money_info.total_ship_fee,
          payment: orderInfo.payment_type == 'Offline' ? '2' : '1',
          platform: { 'AliPay': '支付宝', 'WeixinPay': '微信', 'UnionPay': '银联', 'HuabeiPay': '支付宝'}[orderInfo.payment_type] || orderInfo.payment_type,
          uid: this.$store.state?.userInfo?.id || ''
        });
      }
    },
    // 付款成功上报
    paysuccessreport(orderInfo) {
      let actionField ={
        step: 5,
        currencyCode: 'CNY',
        id: orderInfo.order_sn,                                                                      // Order ID
        affiliation: orderInfo.trade_type != 'NATIVE' ? 'Mobile' : 'Desktop',                        // Store name
        revenue: orderInfo.total_amount,                                                             // 总金额（含增值税，含运费）
        revenueHt: orderInfo.total_amount,                                                           // 总金额（不含增值税），包括运费
        tax: '0.00',                                                                                 // 税费
        shipping: orderInfo.detail.money_info.total_ship_fee,                                        // 邮费
        transactionGift: 'False',                                                                    // Gift
        transactionShippingService: 'SF',                                                            // 快递
        transactionShippingFree: orderInfo.detail.money_info.total_ship_fee == 0 ? 'True' : 'False', // 免邮
        transactionPayment: orderInfo.payment_type || '',                                            // 支付方式
        coupon: '',                                                                                  // 优惠码
        coupon_id: ''                                                                                // 优惠券ID
      }
      api[types.REPORT_PAY_SUCESS]({actionField}).then(res => {
        console.log(res)
      }).catch(err => {
        console.warn(err);
      });
    },
    // 百度
    bdTrackPayment(orderInfo) {
      if (!orderInfo) return false;
      utils.bdTracker('payment_success', {
        order_id: orderInfo.order_sn,
        order_amount: orderInfo.detail?.money_info?.total_product_price,
        order_amount_paid: orderInfo.total_amount,
        use_coupon: '',
        coupon_id: '',
        coupon_amount: '',
        use_m_point: 0,
        m_point_amount: 0,
        discount: orderInfo.detail?.money_info?.total_discount,
        freight_cost: orderInfo.detail?.money_info?.total_ship_fee,
        payment_method: orderInfo.payment_type
      });
      if (Array.isArray(orderInfo.detail.goods_list) && orderInfo.detail.goods_list.length) {
        orderInfo.detail.goods_list.forEach(group => {
          if (Array.isArray(group.main) && group.main.length) {
            group.main.forEach(o => {
              utils.bdTracker('receipt_detail', {
                order_id: orderInfo.order_sn,
                product_id: o.spu,
                product_name: o.name,
                product_sku: o.sku,
                product_category: '',
                product_quantity: ~~o.qty,
                product_price: ~~o.product_amount_total,
                product_amount: ~~o.original_price,
                product_amount_paid: o.order_amount_total * o.qty
              });
            });
          }
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .pay_query--wrapper {
    padding: 5rem 0;
    .pay_query {
      display: flex; flex-direction: column; justify-content: flex-start; align-items: center;
      .loading { width: 10rem; height: auto; }
      .loading_txt { font-size: 0.875rem; color: #575757; line-height: 1.25rem; }
    }
  }
</style>